import { Interp } from '../../lib/render.jsx';

export default function DuoInvite({ v }) {
  if (!v.showDuoInvite) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "98", "padding": "20px" }}>
        <div className="gp-venster" style={{ "width": "min(400px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "16px" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "11px" }}>
            <img alt="" src={v.duoInviteAvatar} style={{ "width": "44px", "height": "44px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
            <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.4" }}>
              <Interp v={v.duoInviteText} />
            </div>
          </div>
          <div style={{ "fontSize": "14px", "fontWeight": "600", "color": "var(--tekst-2)", "lineHeight": "1.4" }}>
            Jullie tekenen samen op één brede plaat van 64×32. Je ziet elkaars pixels live verschijnen.
          </div>
          <div style={{ "display": "flex", "gap": "8px", "justifyContent": "flex-end" }}>
            <button onClick={v.declineDuo} className="gp-btn">
              Nu niet
            </button>
            <button onClick={v.acceptDuo} className="gp-btn pink">
              Ik doe mee!
            </button>
          </div>
        </div>
      </div>
      {' '}
    </>
  );
}
